import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { UploadComponent } from '../components/upload/upload.component';

@Injectable({ providedIn: 'root' })
export class BackgroundProcessGuard implements CanDeactivate<UploadComponent> {
    canDeactivate(component: UploadComponent): boolean {
        if (component.isUploading) {
            const userConfirmed = confirm('A background process is still running. Are you sure you want to leave this page?');

            if (!userConfirmed) {
                component.onNavigationCancelled?.();
            } 

            return userConfirmed; 
        }

        return true;
    }
}
